import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import { Formik, Form } from "formik";
import * as yup from "yup";
import SmsDogrulamaSaveAPI, { SmsDogrulamaSaveRequest } from "../../../apis/OB/SaveApi/SmsDogrulamaSaveAPI";
import Recaptcha from "../../Recaptcha";
import SmsKoduKontrolAPI, { SmsDogrulamaKontrolRequest } from "../../../apis/OB/SaveApi/SmsKoduKontrolAPI";
import { useNavigate } from "react-router";
import { MuiTelInput } from "mui-tel-input";

const validationSchema = yup.object({
  tcKimlikNo: yup
    .string()
    .required("T.C. Kimlik Numarası zorunludur")
    .length(11, "T.C. Kimlik Numarası 11 haneli olmalıdır."),
  cepTelefonu: yup
    .string()
    .required("Cep Telefonu zorunludur")
    .length(17, "Cep Telefonu 11 haneli olmalıdır."),
});

const TcTelefonSmsControlPopup = (props: any) => {
  const [isError, setIsError] = useState(false);
  const [goSmsControl, setGoSmsControl] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const [isActive, setIsActive] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [errorContent, setErrorContent] = useState("");
  const [refNo, setRefNo] = useState<any>(undefined);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const navigate = useNavigate();
  const recaptchaTokenRef: any = useRef();

  useEffect(() => {
    if (goSmsControl) {
      setIsActive(true);
    }
  }, [goSmsControl]);
  function maskPhoneNumber(phoneNumber: string): string {
    // Telefon numarasındaki boşlukları temizle
    const cleanedNumber = phoneNumber.replace(/\s+/g, "");

    // Telefon numarasının uzunluğu doğrulandıktan sonra maskeleme işlemi yapılır
    if (cleanedNumber.length === 13 && cleanedNumber.startsWith("+90")) {
      const countryCode = cleanedNumber.substring(0, 3); // "+90"
      const firstTwoDigits = cleanedNumber.substring(3, 5); // "53"
      const lastTwoDigits = cleanedNumber.substring(cleanedNumber.length - 2); // "45"

      // Maskeleme
      return `${countryCode} ${firstTwoDigits}* *** ** ${lastTwoDigits}`;
    }

    // Eğer numara formatı uymazsa, olduğu gibi döndür
    return phoneNumber;
  }
  useEffect(() => {
    let interval: any = null;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      setIsActive(false);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const restartTimer = () => {
    setSeconds(60);
    setIsActive(true);
  };

  const handleRecaptchaChange = (value: boolean) => {
    setRecaptchaPassed(value);
  };

  return (
    <Dialog open={true} onClose={() => navigate(-1)}>
      <Formik
        enableReinitialize
        initialValues={{
          tcKimlikNo: "",
          cepTelefonu: "",
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {

          const recaptchaToken = await recaptchaTokenRef.current?.handleSubmit();

          if (recaptchaToken) {

            let request = new SmsDogrulamaSaveRequest(
              values.cepTelefonu.replace(/^\+9/, "").replace(/ /g, ""),
              values.tcKimlikNo,
              undefined,
              undefined,
              undefined,
              recaptchaToken, // Token burada gönderiliyor
              //false
            );
            props.tcKimlikNoSet(values.tcKimlikNo)
            if(props.cepTelefonuSet!=undefined)
              props.cepTelefonuSet(values.cepTelefonu)
            SmsDogrulamaSaveAPI.saveSmsDogrulamaSaveSave(request)
              .then((res) => {
                if (res.data.sonuc === 0) {
                  setRefNo(request.referansNo);
                  setGoSmsControl(true);
                } else {
                  setErrorContent(res.data.sonucAciklama);
                  setIsError(true);
                  recaptchaTokenRef.current?.reset();
                  setTimeout(() => {
                    setIsError(false);
                    setErrorContent("");
                  }, 4000);
                }
              })
              .catch((err) => {
                //setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
                recaptchaTokenRef.current?.reset();
                //setIsError(true);
                /*setTimeout(() => {
                  setIsError(false);
                  setErrorContent("");
                }, 4000);*/
              })
              .finally(() => {
                setSubmitting(false);
              });
          } else {
            // setErrorContent("Lütfen reCAPTCHA'yı doğrulayın.");
            // setIsError(true);
            setSubmitting(false); // Submit işlemini sonlandır
            //setTimeout(() => {
            //  setIsError(false);
            //  setErrorContent("");
            //}, 4000);
          }
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, errors, touched, isSubmitting, setFieldValue }) => {
          const handleSmsSubmit = async () => {
            if (smsCode.length < 6) {
              setErrorContent("SMS kodu 6 haneli olmalıdır.");
              setIsError(true);
              setTimeout(() => {
                setIsError(false);
                setErrorContent("");
              }, 4000);
            } else {
              let request = new SmsDogrulamaKontrolRequest(
                values.tcKimlikNo,
                refNo,
                smsCode,
                undefined,
                undefined
              );

              SmsKoduKontrolAPI.saveSmsDogrulamaKontrolSave(request)
                .then((res) => {
                  if (res.data[0].sonuc === 0) {
                    props.smsControlledSet(true);
                  } else {
                    setErrorContent(res.data[0].sonucAciklama);
                    setIsError(true);
                    setTimeout(() => {
                      setIsError(false);
                      setErrorContent("");
                    }, 10000);
                  }
                })
                .catch((err) => {
                  setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
                  setIsError(true);
                  setTimeout(() => {
                    setIsError(false);
                    setErrorContent("");
                  }, 4000);
                });
            }
          };
          return (
            <Form onSubmit={handleSubmit}>
              {!goSmsControl ? (
                <>
                  <DialogTitle >
                    Telefon Kontrolü
                    <IconButton
                      aria-label="close"
                      onClick={() => navigate(-1)}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent className="pt-3">
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                      <TextField
                        size="small"
                        fullWidth
                        name="tcKimlikNo"
                        label="T.C. Kimlik No"
                        inputProps={{
                          maxLength:11
                        }}
                        variant="outlined"
                        value={values.tcKimlikNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.tcKimlikNo && Boolean(errors.tcKimlikNo)}
                        helperText={touched.tcKimlikNo && errors.tcKimlikNo}
                      />
                      <MuiTelInput
                        name="cepTelefonu"
                        fullWidth
                        defaultCountry="TR"
                        onlyCountries={["TR"]}
                        className="mb-3"
                        size="small"
                        label="Cep Telefonu *"
                        value={values.cepTelefonu}
                        inputProps={{ maxLength: 17 }}
                        error={
                          errors.cepTelefonu &&
                            touched.cepTelefonu
                            ? true
                            : false
                        }
                        onChange={(value: any) => {
                          const prefix = "+90";
                          if (!value.startsWith(prefix)) {
                            value = prefix + value.replace(/^\+90/, "");
                          }
                          setFieldValue("cepTelefonu", value);
                        }}
                        variant="outlined"
                      />

                      <Collapse in={isError}>
                        <Alert severity="error">{errorContent}</Alert>
                      </Collapse>
                      <Recaptcha ref={recaptchaTokenRef} changeHandleRecaptcha={handleRecaptchaChange} />
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    {/* <Button
                    onClick={() => navigate(-1)}
                   
                    color="secondary"
                  >
                    İptal
                  </Button> */}
                    <Button
                      type="submit"

                      color="primary"
                    // disabled={isSubmitting || !recaptchaPassed} 
                    >
                      Gönder
                    </Button>
                  </DialogActions>
                </>
              ) : (
                <>
                  <DialogTitle>
                    Sms Kontrolü
                    <IconButton
                      aria-label="close"
                      onClick={() => navigate(-1)}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                      {isActive ? (
                        <Typography>
                          {maskPhoneNumber(values.cepTelefonu)+" "}
                          numaralı telefona gönderilen SMS kodunu giriniz.
                        </Typography>
                      ) : (
                        <Typography>Kodu girmediniz. Tekrar göndermeyi deneyin.</Typography>
                      )}
                      <Collapse in={isError}>
                        <Alert severity="error">{errorContent}</Alert>
                      </Collapse>
                      {isActive && (
                        <TextField
                          size="small"
                          fullWidth
                          name="smsCode"
                          label="SMS Kodu"
                          variant="outlined"
                          value={smsCode}
                          onChange={(e) => setSmsCode(e.target.value.substring(0, 6))}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSmsSubmit(); // Enter'a basınca aynı işlem çağrılır
                            }
                          }}
                        />
                      )}
                      <Typography variant="h6">{seconds}</Typography>
                    </Box>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={() => {
                        setSmsCode("");
                        let request = new SmsDogrulamaSaveRequest(
                          values.cepTelefonu,
                          values.tcKimlikNo,
                          undefined,
                          undefined,
                          undefined
                        );

                        SmsDogrulamaSaveAPI.saveSmsDogrulamaSaveSave(request)
                          .then((res) => {
                            if (res.data.sonuc === 0) {
                              setRefNo(request.referansNo);
                              setGoSmsControl(true);
                            } else {
                              setErrorContent(res.data.sonucAciklama);
                              setIsError(true);
                              setTimeout(() => {
                                setIsError(false);
                                setErrorContent("");
                              }, 4000);
                            }
                          })
                          .catch((err) => {
                            /*setErrorContent("Bir hata oluştu. Lütfen tekrar deneyin.");
                            setIsError(true);
                            setTimeout(() => {
                              setIsError(false);
                              setErrorContent("");
                            }, 4000);*/
                          });
                        restartTimer();

                      }}
                      disabled={isActive}
                    >
                      Tekrar Gönder
                    </Button>
                    <Button
                      onClick={() => handleSmsSubmit()}



                      color="primary"
                    >
                      Tamam
                    </Button>
                  </DialogActions>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default TcTelefonSmsControlPopup;